'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _HlsJs = require('./HlsJs');

var _HlsJs2 = _interopRequireDefault(_HlsJs);

var _HlsJsLoader = require('./HlsJsLoader');

var _HlsJsLoader2 = _interopRequireDefault(_HlsJsLoader);

var _HlsJsPlayer = require('./HlsJsPlayer');

var _HlsJsPlayer2 = _interopRequireDefault(_HlsJsPlayer);

var _PlayerFactory2 = require('../models/PlayerFactory');

var _PlayerFactory3 = _interopRequireDefault(_PlayerFactory2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-plusplus */
var HlsJsPlayerFactory = function (_PlayerFactory) {
  (0, _inherits3.default)(HlsJsPlayerFactory, _PlayerFactory);

  function HlsJsPlayerFactory(hlsJsResourceUrl) {
    (0, _classCallCheck3.default)(this, HlsJsPlayerFactory);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HlsJsPlayerFactory.__proto__ || (0, _getPrototypeOf2.default)(HlsJsPlayerFactory)).call(this));

    _this.hlsJsResourceUrl = hlsJsResourceUrl;
    _this.hlsJsPlayerInstances = 0;
    return _this;
  }

  (0, _createClass3.default)(HlsJsPlayerFactory, [{
    key: 'createPlayer',
    value: function createPlayer() {
      var hlsJsLibrary = new _HlsJs2.default(new _HlsJsLoader2.default(this.hlsJsResourceUrl));

      var containerId = 'hlsjs_player_' + this.hlsJsPlayerInstances;
      this.hlsJsPlayerInstances++;
      var containerElement = document.createElement('div');
      containerElement.setAttribute('id', containerId);
      containerElement.setAttribute('style', 'width: 0px; height: 0px; display: none;');

      var videoElement = document.createElement('video');
      containerElement.appendChild(videoElement);
      document.body.appendChild(containerElement);
      return new _HlsJsPlayer2.default(hlsJsLibrary, videoElement, containerId);
    }
  }]);
  return HlsJsPlayerFactory;
}(_PlayerFactory3.default);

exports.default = HlsJsPlayerFactory;
//# sourceMappingURL=HlsJsPlayerFactory.js.map